import { EMAIL_REGEX, FREE_TEXT_REGEX } from '../regexConstants'

export default [
  {
    name: 'email',
    label: 'Email Address',
    errorMessage: 'Enter your email address',
    required: true,
    type: 'text',
    pattern: EMAIL_REGEX,
  },
  {
    name: 'password',
    label: 'Password',
    errorMessage: 'Enter your password',
    required: true,
    type: 'password',
    pattern: FREE_TEXT_REGEX,
  },
]
